import React from 'react'

import {AiFillGithub} from 'react-icons/ai';
import {AiFillLinkedin} from 'react-icons/ai';
import {BsFacebook} from 'react-icons/bs';
import {BsInstagram} from 'react-icons/bs';
const Headersocial = () => {
  return (
    <div className="header__social">
        <a href="https://www.linkedin.com/in/rahul-batham767/" target="_blank" rel="noreferrer"><AiFillLinkedin/></a>
        <a href="http://github.com/rahulbatham767" target="_blank" rel='noreferrer'><AiFillGithub/></a>
        <a href="https://www.facebook.com/rahul.batham.3726613" target="_blank" rel="noreferrer"><BsFacebook/></a>
        <a href="https://www.facebook.com/rahul.batham.3726613" target="_blank" rel="noreferrer"><BsInstagram/></a>
        
    </div>
  )
}

export default Headersocial